"use client";

// Route-segment error boundary for the (frontend) tree. Renders a friendly,
// on-brand fallback instead of a raw stack trace. The `error` object is
// available for client-side logging, but its message/stack is never shown to
// the user in production. `reset()` re-renders the segment to retry.
export default function Error({
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <main
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: "1rem",
        padding: "4rem 1.5rem",
        color: "var(--foreground)",
      }}
    >
      <h1
        style={{
          fontFamily: "var(--font-title)",
          fontSize: "clamp(1.75rem, 4vw, 2.5rem)",
          margin: 0,
        }}
      >
        Something went wrong
      </h1>
      <p
        style={{
          fontFamily: "var(--font-body)",
          fontSize: "1.125rem",
          maxWidth: "32rem",
          opacity: 0.8,
          margin: 0,
        }}
      >
        An unexpected error stopped this page from loading. You can try again,
        and if it keeps happening, please come back a little later.
      </p>
      <button
        type="button"
        onClick={() => reset()}
        style={{
          fontFamily: "var(--font-title)",
          fontSize: "1rem",
          padding: "0.625rem 1.5rem",
          borderRadius: "999px",
          border: "1px solid var(--foreground)",
          background: "var(--foreground)",
          color: "var(--background)",
          cursor: "pointer",
        }}
      >
        Try again
      </button>
    </main>
  );
}
